/**
 *
 *
 *
 */

const indexFilter = () => {
  const menu = document.getElementById('js-people-menu');

  if (menu === null) {
    return;
  }

  const menuLinks = menu.querySelectorAll('a');

  if (menuLinks.length < 1) {
    return;
  }

  const content = document.querySelectorAll('.c-person-card');

  if (content.length < 1) {
    return;
  }

  menu.addEventListener('click', (event) => {
    if (!(event.target instanceof HTMLAnchorElement)) {
      return;
    }

    event.preventDefault();

    const targetElem = event.target;
    const { href } = targetElem;

    /**
     *  If the link has a trailing slash, the last part from the split will be an empty string.
     *  The `filter()` method removes empty strings from the array, so the last part is a non-empty string.
     *  (`filter()` implicitly returns false for empty strings.)
     */
    const slug = href
      .split('/')
      .filter((elem) => elem)
      .slice(-1)
      .toString();

    menuLinks.forEach((elem) => {
      elem.classList.remove('is-active-group');
      elem.classList.add('is-not-active-group');
    });

    targetElem.classList.remove('is-not-active-group');
    targetElem.classList.add('is-active-group');

    if (slug === 'people') {
      content.forEach((elem) => {
        elem.classList.remove('is-hidden');
        elem.classList.add('is-visible');

        // setTimeout(() => {
        //   elem.classList.remove('is-transparent');
        //   elem.classList.add('is-opaque');
        // }, 12.5);
      });
    } else {
      const contentGroup = document.querySelectorAll(`.js-${slug}`);

      content.forEach((elem) => {
        elem.classList.remove('is-visible');
        elem.classList.add('is-hidden');
        // elem.classList.remove('is-opaque');
        // elem.classList.add('is-transparent');
      });

      contentGroup.forEach((elem) => {
        elem.classList.remove('is-hidden');
        elem.classList.add('is-visible');

        // setTimeout(() => {
        //   elem.classList.remove('is-transparent');
        //   elem.classList.add('is-opaque');
        // }, 12.5);
      });
    }
  });
};

indexFilter();

export default indexFilter;
